import React, { useState } from "react";
import styles from "./register.module.css";
import axios from "axios";

const Form = () => {
  const [formData, setFormData] = useState({
    city: "",
    name: "",
    email: "",
    contact_number: "",
    instrument: "",
    backup_contact: "",
    composition_link: "",
    past_achievements: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation (can be enhanced)
    if (!formData.city || !formData.name || !formData.email) {
      alert("Please fill in all required fields.");
      return;
    }

    try {
      const response = await axios.post(
        "https://ashish.moodi.org/livewire/strings_reg",
        formData
      );
      if (response.status === 200) {
        alert("Registration successful!");
        window.location.reload();
      }
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      alert("There was an error submitting the form. Please try again.");
    }
  };

  return (
    <div className={styles.container}>
      <p className={styles.title}>REGISTER NOW</p>
      <div className={styles.rulesContainer}>
        <h2 className={styles.rulesTitle}>Rules</h2>
        <ul className={styles.rulesList}>
          <li>
            Individuals must submit and perform their own original compositions.
          </li>
          <li>
            The entire sound should be produced live, and pre-recorded samples
            require prior approval from organizers.
          </li>
          <li>The individuals should not be college students.</li>
          <li>
            Advance notification to organizers is mandatory for the use of any
            instrument.
          </li>
          <li>There are no language and genre restrictions on the band.</li>
        </ul>
      </div>

      <div id="register">
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSfUIF8YYNhK6pFNCvpKxfEvjAH5mOC8vJ7e4HWUmVp_KggLzA/viewform"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className={`${styles.registerBtn} ${styles.redbtn}`}>REGISTER</button>
        </a>
      </div>
    </div>
  );
};

export default Form;
